import { FC } from 'react';
import { GridRender } from '@base/snippets/GridRender';
import { Trans, useTrans } from 'base/utils/i18n';
import { IVariant } from 'base/interfaces/product';
import { getWholesaleRangeIndex, hasWholeSalePrice, getUnitsRange, getSuggestedPriceExchangeDisplay, getWholesalePriceExchangeDisplay, getWholesalePriceExchange } from '@pro/product/utils';
import { splitGroups } from 'base/utils/arr';
import { LoopRender } from '@base/snippets/LoopRender';
import { ProdVat } from 'mod/product/ProdVat';
import cn from 'classnames';
import styles from './index.module.less';

type IProdWholesaleInfoProps = {
    shownVariant: IVariant;
    qty: number;
    className?: string;
};

export const ProdWholesaleInfo: FC<IProdWholesaleInfoProps> = props => {
    const { t } = useTrans();
    const { shownVariant, qty, className } = props;
    const activeRangeIndex = getWholesaleRangeIndex(shownVariant.wholesalePrices, qty);

    return (
        <div className={cn(className, styles.info)}>
            <div className={'g-text g-mb'}>{t('web_wholesale_min_order_qty', { qty: shownVariant.wholesaleMinSaleQuantity })}</div>

            {hasWholeSalePrice(shownVariant) ? (
                <>
                    <LoopRender
                        tag={false}
                        list={splitGroups(shownVariant.wholesalePrices, 3)}
                        render={(group, { index: groupIndex }) => (
                            <GridRender
                                className={'g-ranges g-mb'}
                                colsPerRow={3}
                                list={group}
                                colProps={(item, index) => ({
                                    className: cn('g-range', { 'g-active': activeRangeIndex === (index + (groupIndex * 3)) })
                                })}
                                render={(item, index) => (
                                    <>
                                        <div className={'g-units'}>
                                            <Trans
                                                i18nKey="web_wholesale_range_units"
                                                components={{ Range: getUnitsRange(item) }}
                                            />
                                        </div>
                                        <div className={'g-price'}>{item.shopPriceExchangeDisplay}</div>
                                    </>
                                )}
                            />
                        )}
                    />
                </>
            ) : (
                <div className={'g-shop-price g-mb'}>
                    {getWholesalePriceExchangeDisplay(shownVariant)}
                </div>
            )}

            <div className={'g-text g-mb'}>
                {t('web_wholesale_suggested_retail_price')}: {getSuggestedPriceExchangeDisplay(shownVariant)}
            </div>
            <div className={'g-text'}>
                {t('web_wholesale_30d_avg_price')}: {shownVariant.averagePrice.averagePrice30ExchangeDisplay}
            </div>
            {shownVariant.vat && (
                <div className={'g-text g-mt'}>
                    {t('web_shop_product_price_vat_tips')}
                </div>
            )}
        </div>
    )
};
